import BaseModelService from '../../base/base_model_service.js';
import _ from '../../utils/underscore';
import Strings from '../../utils/strings';


/**
 *
 *
 *
 */
class IntegrationModel extends BaseModelService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'IntegrationModel';


    /**
     * @property
     * @type {string[]}
     * @private
     */
    _allowedRoles = [
        'b2c',
        'dev'
    ];


    /**
     * @property
     * @type {string}
     * @private
     */
    _defaultRole = 'dev';


    /**
     * Define default marketing data.
     *
     * @type {null}
     * @private
     */
    _marketData = null;


    /**
     * Define marketing flow type.
     *
     * @type {null}
     * @private
     */
    _marketingFlowType = null;


    /**
     * Orbit header element
     * @type {null}
     * @private
     */
    _headerElementMethod = null;

    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);

        if (params) {
            this
                .setRole(params.role)
                ._setHeaderElementMethod(params.headerElement)
                ._setHeaderRegulationDataElement(params.headerRegulationDataElement)
                ._setProxyLink(params.proxyLink)
                ._setGameTypeMapper(params.gameTypeMapper)
                ._setGamesList(params.gamesList)
                ._setParamsUrl(params.urlSessionParams)
                ._setHistoryLink(params.historyLink)
                ._setGameSessionHistoryLink(params.gameSessionHistoryLink)
                ._setAboutHelpLink(params.aboutHelpLink)
                ._setLobbyUrlLink(params.lobbyUrlLink)
                ._setLegalInfoLink(params.legalInfoLink)
                ._setThirdPartyCookieLink(params.thirdPartyCookieLink)
                ._setMDPImageMapper(params.MDPImageMapper)
                ._setRichSettings(params.rich)
                ._setCMSSource(params.CMSSource)
                ._setOpenInNewWindowHook(params.openInNewWindowHook)
                ._setIsMiniCipFunc(params.isMiniCipFunc)
                ._setIsMiniCisFunc(params.isMiniCisFunc);
        }
    }

    _richSettings = {};


    /**
     * @param richSettings
     * @returns {IntegrationModel}
     * @private
     */
    _setRichSettings(richSettings) {
        this._richSettings = richSettings || {};
        return this;
    }


    /**
        _openInNewWindowHook is a function that returns another function. This is a parameter provided by orbit and is necessary in mini orbit mode to handle external links.
     */
    _openInNewWindowHook = null;
    getOpenInNewWindowHook() {
        return this._openInNewWindowHook;
    }

    _setOpenInNewWindowHook(openInNewWindowHook) {
        this._openInNewWindowHook = openInNewWindowHook;
        return this;
    }

    _isMiniCipFunc = null;
    _setIsMiniCipFunc(isMiniCipFuc) {
        this._isMiniCipFunc = isMiniCipFuc;
        return this;
    }

    getIsMiniCip() {
        if (_.isFunction(this._isMiniCipFunc)) {
            return this._isMiniCipFunc();
        }

        return false;
    }

    _isMiniCisFunc = null;
    _setIsMiniCisFunc(isMiniCisFuc) {
        this._isMiniCisFunc = isMiniCisFuc;
        return this;
    }

    getIsMiniCis() {
        if (_.isFunction(this._isMiniCisFunc)) {
            return this._isMiniCisFunc();
        }

        return false;
    }

    getHeaderRegulationDataElement() {
        return this._headerRegulationDataElementMethod();
    }

    _setHeaderRegulationDataElement(headerRegulationDataElementMethod) {
        if (_.isFunction(headerRegulationDataElementMethod)) {
            this._headerRegulationDataElementMethod = headerRegulationDataElementMethod;
        } else {
            this._setHeaderRegulationDataElement = () => Promise.resolve(null);
        }

        return this;
    }

    _setHeaderElementMethod(headerElementMethod) {
        if (_.isFunction(headerElementMethod)) {
            this._headerElementMethod = headerElementMethod;
        } else {
            this._headerElementMethod = () => Promise.resolve(null);
        }

        return this;
    }

    /**
     * @returns {string}
     */
    getRichPageUrl(campaignId) {
        if (!this._richSettings.richPageUrl) {
            this.throwError('178', 'RICH page URL was not provided in the integration');
        }

        let richPageUrl = new Strings(this._richSettings.richPageUrl);
        return richPageUrl.injectIntoCurly({campaignid: campaignId});
    }

    /**
     * Set the new role.
     *
     * @param role
     * @returns {IntegrationModel}
     */
    setRole(role = this._defaultRole) {
        if (!_.isString(role)) {
            this._role = this._defaultRole;
        }

        let allowedRole = this._allowedRoles.find(r => r === role);

        this._role = !_.isUndefined(allowedRole) ? allowedRole : this._defaultRole;
        return this;
    }


    /**
     * Set third party cookie link from initialization.
     *
     * @param thirdPartyCookieLink
     * @returns {IntegrationModel}
     * @private
     */
    _setThirdPartyCookieLink(thirdPartyCookieLink = '') {
        if (!_.isString(thirdPartyCookieLink)) {
            this._thirdPartyCookieLink = '';
            return this;
        }

        this._thirdPartyCookieLink = thirdPartyCookieLink;
        return this;
    }


    /**
     * Update marketing flow type.
     *
     * @param marketingFlowType
     * @returns {IntegrationModel}
     * @private
     */
    _updateMarketingFlowType(marketingFlowType = null) {
        if (_.isNull(marketingFlowType) || _.isUndefined(marketingFlowType)) {
            this._marketingFlowType = null;
        }

        this._marketingFlowType = marketingFlowType;
        return this;
    }


    /**
     * Update recent market data model.
     *
     * @param marketData
     * @returns {IntegrationModel}
     * @private
     */
    _updateMarketData(marketData = null) {
        if (_.isNull(marketData) || _.isUndefined(marketData)) {
            this._marketData = null;
        }

        this._marketData = marketData;
        return this;
    }


    /**
     * Set integration game type mapper.
     *
     * @param gameTypeMapperRef
     * @returns {IntegrationModel}
     * @private
     */
    _setGameTypeMapper(gameTypeMapperRef) {
        if (_.isFunction(gameTypeMapperRef)) {
            this._gameTypeMapperRef = gameTypeMapperRef;
        } else {
            this._gameTypeMapperRef = () => Promise.resolve();
        }

        return this;
    }

    /**
     * Setter for a proxy to redirect. This used for pass redirect managing to third party side
     * @param proxyScopeCallback
     * @returns {IntegrationModel}
     * @private
     */
    _setProxyLink(proxyLink) {
        if (!_.isFunction(proxyLink)) {
            return this;
        }

        this._proxyLink = proxyLink;
        return this;
    }


    /**
     * Set list of all games in the site
     * @param gamesList
     * @returns {IntegrationModel}
     * @private
     */
    _setGamesList(gamesList) {
        if (!_.isArray(gamesList)) {
            return this;
        }

        this._gamesList = gamesList;
        return this;
    }


    /**
     * Set integration url for session params.
     *
     * @param url
     * @returns {IntegrationModel}
     * @private
     */
    _setParamsUrl(url) {
        if (!_.isString(url)) {
            return this;
        }

        this._urlParams = url;
        return this;
    }


    /**
     * Setter history link integration parameter.
     *
     * @param historyLink
     * @returns {IntegrationModel}
     * @private
     */
    _setHistoryLink(historyLink) {
        if (!_.isString(historyLink)) {
            this._historyLink = '';
            return this;
        }

        this._historyLink = historyLink;
        return this;
    }

    /**
     * Setter game session history link integration parameter.
     *
     * @param gameSessionHistoryLink
     * @returns {IntegrationModel}
     * @private
     */
    _setGameSessionHistoryLink(gameSessionHistoryLink) {
        this._gameSessionHistoryLink = _.isString(gameSessionHistoryLink) ? gameSessionHistoryLink : '';

        return this;
    }

    /**
     * Setter about link integration parameter.
     *
     * @param aboutHelpLink
     * @returns {IntegrationModel}
     * @private
     */
    _setAboutHelpLink(aboutHelpLink) {
        if (!_.isString(aboutHelpLink)) {
            this._aboutHelpLink = '#';
            return this;
        }

        this._aboutHelpLink = aboutHelpLink;
        return this;
    }


    /**
     * Setter lobby URL link integration parameter.
     *
     * @param lobbyUrlLink
     * @returns {IntegrationModel}
     * @private
     */
    _setLobbyUrlLink(lobbyUrlLink) {
        if (!_.isString(lobbyUrlLink)) {
            this._myAccountToLobbyUrlLink = '#';
            return this;
        }

        this._lobbyUrlLink = lobbyUrlLink;
        return this;
    }



    /**
     * Setter legal info link integration parameter.
     *
     * @param legalInfoLink
     * @returns {IntegrationModel}
     * @private
     */
    _setLegalInfoLink(legalInfoLink) {
        if (!_.isString(legalInfoLink)) {
            this.legalInfoLink = '#';
            return this;
        }

        this._legalInfoLink = legalInfoLink;
        return this;
    }



    /**
     *
     * @returns {*}
     */
    getParamsUrl() {
        return this._urlParams;
    }


    /**
     * Set mapper to MDP messages. Mapper contains definition which message has an image
     *
     * @param mapper
     * @returns {IntegrationModel}
     * @private
     */
    _setMDPImageMapper(mapper = {}) {
        this._MDPImageMapper = mapper;
        if (_.isObject(mapper)) {
            this._MDPImageMapper = mapper;
        }
        return this;
    }
    
    /**
     * Get role from the model.
     *
     * @returns {string|*}
     */
    getRole() {
        return this._role;
    }


    /**
     * Get integration game type mapper reference.
     *
     * @returns {*}
     */
    getGameTypeMapper() {
        return this._gameTypeMapperRef;
    }


    /**
     * Getter history link.
     *
     * @returns {*|string}
     */
    getHistoryLink() {
        return this._historyLink;
    }

    /**
     * Getter game session history link.
     *
     * @returns {*|string}
     */
    getGameSessionHistoryLink() {
        return this._gameSessionHistoryLink;
    }

    /**
     * Getter about help link.
     *
     * @returns {*|string}
     */
    getAboutHelpLink() {
        return this._aboutHelpLink;
    }


    /**
     * Getter lobby URL link.
     *
     * @returns {*|string}
     */
    getLobbyUrlLink() {
        return this._lobbyUrlLink;
    }


    /**
     * Getter legal info link
     *
     * @returns {*}
     */
    getLegalInfoLink() {
        return this._legalInfoLink;
    }


    /**
     * Getter third party cookie link.
     *
     * @returns {string|*}
     */
    getThirdPartyCookieLink() {
        return this._thirdPartyCookieLink;
    }


    /**
     * Get recent market data.
     *
     * @returns {{}|*}
     */
    getRecentMarketData() {
        return this._marketData;
    }

    /**
     * Get current marketing flow type.
     *
     * @returns {{}|*}
     */
    getMarketingFlowType() {
        return this._marketingFlowType;
    }


    /**
     * Get MDP message mapper
     *
     * @returns {{}|*}
     */
    getMDPImageMapper() {
        return this._MDPImageMapper;
    }

    /**
     * Get redirect proxy scope
     * @returns {*|null}
     */
    getProxyLink() {
        return this._proxyLink || null;
    }

    _setCMSSource(cmsSource){
        this._cmsSource = cmsSource || '';
        return this;
    }

    getCMSSource(){
        return this._cmsSource;
    }
}
export default IntegrationModel;